const LANGUAGE_CODE_TO_FLAG: Record<string, string> = {
  en: '🇬🇧',
  'en-us': '🇺🇸',
  'en-gb': '🇬🇧',
  'en-au': '🇦🇺',
  es: '🇪🇸',
  fr: '🇫🇷',
  de: '🇩🇪',
  it: '🇮🇹',
  pt: '🇵🇹',
  'pt-br': '🇧🇷',
  nl: '🇳🇱',
  sv: '🇸🇪',
  no: '🇳🇴',
  nb: '🇳🇴',
  nn: '🇳🇴',
  da: '🇩🇰',
  fi: '🇫🇮',
  pl: '🇵🇱',
  cs: '🇨🇿',
  sk: '🇸🇰',
  hu: '🇭🇺',
  ro: '🇷🇴',
  bg: '🇧🇬',
  el: '🇬🇷',
  uk: '🇺🇦',
  ru: '🇷🇺',
  tr: '🇹🇷',
  ar: '🇸🇦',
  he: '🇮🇱',
  hi: '🇮🇳',
  bn: '🇧🇩',
  ta: '🇮🇳',
  te: '🇮🇳',
  th: '🇹🇭',
  vi: '🇻🇳',
  id: '🇮🇩',
  ms: '🇲🇾',
  fil: '🇵🇭',
  tl: '🇵🇭',
  ja: '🇯🇵',
  ko: '🇰🇷',
  zh: '🇨🇳',
  'zh-cn': '🇨🇳',
  'zh-hans': '🇨🇳',
  'zh-tw': '🇹🇼',
  'zh-hant': '🇹🇼',
  'zh-hk': '🇭🇰',
  yue: '🇭🇰',
}

export const getLanguageFlag = (code: string): string | null => {
  if (!code) return null

  const normalized = code.toLowerCase().replace('_', '-')

  return LANGUAGE_CODE_TO_FLAG[normalized]
    ?? LANGUAGE_CODE_TO_FLAG[normalized.split('-')[0]]
    ?? null
}
